module.exports = __webpack_public_path__ + "static/toboriImg1-5fee3088e3c2e45c226f6cf684722802.jpg";